import { useCallback, useState } from 'react';

import { ORDER, SORTING } from './constants';

export interface UserTableSortingAction {
  type?: string;
}

export interface UserTableSortingHook {
  sorting: string;
  order: string;
  onAction: (action?: UserTableSortingAction) => void;
}

export default function useUserTableSorting(): UserTableSortingHook {
  const [sorting, setSorting] = useState(SORTING.NAME);
  const [order, setOrder] = useState(ORDER.NORMAL);

  const onAction = useCallback(
    (action: UserTableSortingAction = {}) => {
      const { type } = action;

      if (type === 'name-alphabetical') {
        if (sorting !== SORTING.NAME) {
          setSorting(SORTING.NAME);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === 'lastname-alphabetical') {
        if (sorting !== SORTING.LASTNAME) {
          setSorting(SORTING.LASTNAME);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === 'email-alphabetical') {
        if (sorting !== SORTING.EMAIL) {
          setSorting(SORTING.EMAIL);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === 'mobile-alphabetical') {
        if (sorting !== SORTING.MOBILE) {
          setSorting(SORTING.MOBILE);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      if (type === 'company-name-alphabetical') {
        if (sorting !== SORTING.COMPANY) {
          setSorting(SORTING.COMPANY);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }

      setSorting(SORTING.NAME);
      setOrder(ORDER.NORMAL);
    },
    [order, sorting],
  );

  return {
    sorting,
    order,
    onAction,
  };
}
